import { getTaxConf } from "~/utils/betslip/taxes";
import { calculateTotalOdds } from "~/utils/betslip/odds";
import { useAuth } from "~/store/auth";
import { payoutLimitConfig } from "~/utils/betslip/limits";

export const calculatePotentialReturn = (
	bets: { priceNumerator: number; priceDenominator: number }[],
	wagerAmount: number,
	paymentType: 1 | 2 | 4
) => {
	const auth = useAuth();
	const taxConfig = getTaxConf(paymentType);
	const totalOdds = calculateTotalOdds(bets);
	const limit = payoutLimitConfig(bets.length, paymentType);
	const potentialTotal =
		totalOdds * wagerAmount - (wagerAmount * (((taxConfig?.TaxType === "Wager" ? taxConfig?.TaxPercentage : 0) || 0) / 100) || 0);
	const potentialReturn = paymentType === 2 ? potentialTotal - (auth.balance?.bonusBalance ?? 0) : potentialTotal;
	return limit && potentialReturn > limit.PayoutLimit ? limit.PayoutLimit : potentialReturn;
};

export const calculateBoostedPotentialReturnBeforeTax = (count: number, returnAmount: number, winboostTotal: number, paymentType: 1 | 2 | 4) => {
	const potentialReturnBeforeTax = (paymentType === 2 ? 0 : winboostTotal) + returnAmount;

	const limit = payoutLimitConfig(count, paymentType);
	return limit && potentialReturnBeforeTax > limit.PayoutLimit ? limit.PayoutLimit : potentialReturnBeforeTax;
};

export const calculateTotalPotentialReturn = (returnAmount: number, tax: number, isScratch: boolean = false) => {
	if (isScratch) return returnAmount;
	return returnAmount - tax;
};
